import { Flame } from "lucide-react";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

const sizeClasses = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-14 h-14",
};

const textSizeClasses = {
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-4xl",
};

export const Logo = ({ size = "md", showText = true }: LogoProps) => {
  return (
    <div className="flex items-center gap-3">
      <div className={`${sizeClasses[size]} relative flex items-center justify-center`}>
        <div className="absolute inset-0 bg-gradient-ember rounded-lg opacity-20 blur-sm" />
        <div className="relative bg-gradient-ember rounded-lg p-2 shadow-ember">
          <Flame className="w-full h-full text-primary-foreground glow-ember" />
        </div>
      </div>
      {showText && (
        <span className={`font-display ${textSizeClasses[size]} tracking-wider text-gradient-ember`}>
          MŌDFORGE
        </span>
      )}
    </div>
  );
};
